import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from '@mui/material';
const SubmitButton = ({ label, disabled, }) => (_jsx(Button, { fullWidth: true, type: "submit", className: "site-system-button-primary", disabled: disabled, children: label }));
export default SubmitButton;
//# sourceMappingURL=SubmitButton.js.map